import { render, staticRenderFns } from "./VIPcenter.vue?vue&type=template&id=8b772708&scoped=true&"
import script from "./VIPcenter.vue?vue&type=script&lang=js&"
export * from "./VIPcenter.vue?vue&type=script&lang=js&"
import style0 from "./VIPcenter.vue?vue&type=style&index=0&id=8b772708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b772708",
  null
  
)

export default component.exports